// extracted by mini-css-extract-plugin
export default {"story-menu":"StoryMenuAdmin_story-menu__yi+Q4"};